export default {
  pages_presence: {
    about_us: true,
    delivery_and_payment: true,
    blog: true,
    offers: true,
    legal_profile: false,
  },

  products: {
    display_description: true,
    display_variant_option_label: 'product_page',
    cart_button_visibility: 'on_hover',
    cart_button_available: 'В корзину',
    cart_button_unavailable: 'Заказать',
    card_image_aspect_ratio: 1.5,
    card_image_object_fit: 'cover',
    card_shadow_size: '0',
    card_shadow_opacity:'16',
    card_hover_shadow_size: '10',
    card_hover_shadow_opacity:'16',
    card_border_width: '1',
    cards_count_desktop: '4',
    modifiers_visibility: 'always',
    display_nested_categories: 'always',
  },

  appbars: {
    desktop_variant: '1',
    mobile_variant: 'mm01',
    disable_mobile_specific_appbar: false,
  },

  sidebar: {
    fixed: 'gt_md',
    variant: '1',
  },

  search: {
    placeholder: 'Поиск по товарам',
  },

  logos: {
    header: require('@/assets/images/logo.svg'),
    footer: require('@/assets/images/logo.svg'),
    favicon: '',
  },

  seo: {
    include_store_name: 'after',
    title_divider: ' — ',
    og_image: '',
  },

  delivery: {
    restrict_to_city: true,
    extra_address_fields_state: 'collapsed',
    notes_field_state: 'collapsed',
    address_hint: '',
  },

  yandex_metrika: {
    yandex_metrika_id: '',
    yandex_metrika_webvisor: false,
    yandex_metrika_ecommerce: false,
  },

  facebook_pixel: {
    id: '',
  },

  vk_pixel: {
    id: '',
  },

  feedback_form: {
    name_enabled: true,
    message_enabled: true,
    contact_type: 'phone',
  },

  legal_docs: {
    privacy_policy: true,
    personal_data: true,
    eula: false,
  },

  orders: {
    thank_you_title: 'Спасибо за заказ',
    thank_you_text: '',
    thank_you_image: '',
    checkout_enabled: false,
  },

  home_seo: {
    title: 'Главная',
    description: '',
    og_image: '',
  },

  home_promo: {
    visibility: 'always',
    heading: 'Большие и качественные роллы с доставкой',
    subheading: '',
    background: require('@/assets/images/home/home-background.jpg'),
    promo_button: 'Каталог товаров',
    promo_button_visibility: 'always',
  },

  home_features: {
    visibility: 'always',
    order: 1,
    list: [
      {
        image: require('@/assets/images/home/features/format.svg'),
        title: 'Качественные продукты',
        content: 'Только дорогие продукты и проверенные поставщики',
      },
      {
        image: require('@/assets/images/home/features/operator.svg'),
        title: 'Бесплатная доставка',
        content: 'При заказе от 500 руб',
      },
      {
        image: require('@/assets/images/home/features/offers.svg'),
        title: 'Бонусы',
        content: 'Возвращаем 10% от каждого заказа',
      },
      {
        image: require('@/assets/images/home/features/guarantee.svg'),
        title: 'Большой выбор',
        content: 'Роллы и суши на любой вкус',
      },
    ],
  },

  home_offers: {
    visibility: 'always',
    order: 2,
    variant: 'cards',
    full_width_variant_card_size: 'padded',
    subvariant: 'aspectRatioIgnore',
    display_text: true,
    // Aspect ratio is chosen so that it matches the aspect ratio of the old variant's images.
    image_aspect_ratio_width: 12,
    image_aspect_ratio_height: 7,
    image_brightness_percent: 70,
    title: 'Акции',
    subtitle: '',
    sorting: 'desc',
  },

  home_categories: {
    visibility: 'never',
    order: 3,
    categories_to_display_select: 'all_root',
    categories_list: [],
    display_names: 'always',
  },

  home_products_collection: {
    visibility: 'always',
    order: 3,
    collection_id: '',
    title: 'Избранные товары',
    count: -1,
  },

  home_feedback: {
    visibility: 'always',
    order: 4,
    title: 'У вас есть вопросы или предложения?',
    content: 'Оставьте сообщение и мы обязательно свяжемся с вами',
    label: 'Ваш вопрос или предложение',
  },

  about_us_seo: {
    title: 'О компании',
    description: '',
    og_image: '',
  },

  about_us_menu: {
    title: 'О компании',
  },

  about_us_promo: {
    display: true,
    background: require('@/assets/images/about-us/background.jpg'),
    background_gradient: true,
    without_context_background: true,
    title: 'Более 5 лет готовим японские блюда',
    content: [
      '– Знаем все тонкости мастерства',
      '– Правильное сочетание продуктов',
      '– Опытные повара',
    ].join("\n")
  },

  about_us_cards: {
    display: true,
    icon: '',
    title: 'Знаем все тонкости мастерства',
    list: [
      {
        image: require('@/assets/images/about-us/feature-1.jpg'),
        title: 'Новые рецепты',
        content: 'Мы проверяем каждое новое блюдо и доводим его до идеала. Ведь ролл должен таять во рту и быть сытным.',
      },
      {
        image: require('@/assets/images/about-us/feature-2.jpg'),
        title: 'Свежая рыба',
        content: 'Мы не используем мороженную рыбу, а потому наши роллы максимально передают вкус японских блюд.',
      },
    ],
  },

  about_us_technology: {
    display: true,
    background: require('@/assets/images/about-us/technology-bg.svg'),
    heading: 'Как мы работаем',
    icon: 'fas fa-toolbox',
    title: 'Опытные повара',
    description: 'Мы каждый месяц проводим квалификацию поваров на качество приготовления блюд. Ведь чем качественней блюдо, тем душевней вечер.',
    list: [
      {
        image: require('@/assets/images/about-us/slide-1.jpg'),
      },
    ],
  },

  about_us_staff: {
    display: true,
    heading: 'Наш персонал',
    subheading: 'Мы ценим качество и поэтому принимаем в свою команду только опытных специалистов, чтобы наш клиент был всегда доволен.',
    icon: 'fas fa-users',
    list: [
      {
        image: require('@/assets/images/about-us/staff-placeholder.jpg'),
        title: 'Анастасия Иванова',
        content: 'Шеф-повар',
      },
      {
        image: require('@/assets/images/about-us/staff-placeholder.jpg'),
        title: 'Анастасия Иванова',
        content: 'Шеф-повар',
      },
      {
        image: require('@/assets/images/about-us/staff-placeholder.jpg'),
        title: 'Анастасия Иванова',
        content: 'Шеф-повар',
      },
      {
        image: require('@/assets/images/about-us/staff-placeholder.jpg'),
        title: 'Анастасия Иванова',
        content: 'Шеф-повар',
      },
    ],
  },

  about_us_quality: {
    display: true,
    title: 'Контроль качества<br>на всех этапах',
    description: 'Тщательно отбираем поставщиков продуктов, контролируем по внутренним стандартам работу поваров / пицца-мейкеров / сушистов, используем в экологичную упаковку, бережно доставляем в термосумках.',
    image: require('@/assets/images/about-us/quality-control-schema.png'),
  },

  about_us_feedback: {
    display: true,
    title: 'У вас есть вопросы или предложения?',
    content: 'Оставьте сообщение и мы обязательно свяжемся с вами',
    label: 'Ваш вопрос или предложение',
  },

  blog_list: {
    title: 'Блог',
  },

  blog_seo: {
    title: 'Блог',
    description: '',
    og_image: '',
  },

  blog_menu: {
    title: 'Блог',
  },

  offers_list: {
    title: 'Акции',
    description: '',
  },

  offer_page: {
    display_cover: 'always',
  },

  offers_menu: {
    title: 'Акции',
  },

  offers_seo: {
    title: 'Акции',
    description: '',
    og_image: '',
  },

  delivery_payments_seo: {
    title: 'Доставка и оплата',
    description: '',
    og_image: '',
  },

  delivery_payments_menu: {
    title: 'Доставка и оплата',
  },

  delivery_payments_delivery: {
    display: true,
    display_map: true,
    display_zones: true,
    display_stocks: true,
    definitions: [
      {
        title: 'Доставка по городу',
        content: `<p>
                            Доставка работает только для заказов от 1000 руб.
                            Стоимость доставки по городу зависит от района и суммы заказа.
                        </p>`,
      },
      {
        title: 'Самовывоз из пунктов выдачи',
        content: `<p>
                            Заказы, оформленные на сайте вы можете получить в следующих пунктах выдачи заказов:
                        </p>`,
      },
      {
        title: 'Доставка по России',
        content: `<p>
                            Время доставки составляет от 1 до 12 дней.
                            Стоимость доставки зависит от веса посылки и региона, в который доставляется товар,
                            обычно от 200 руб.
                            Отслеживать посылку вы сможете по номеру накладной (трекеру), который сразу после
                            отгрузки заказа будет отправлен на ваш e-mail, который указан при оформлении заказа.
                        </p>
                        <p>Доставляем следующим компаниями:</p>
                        <ul>
                            <li>СПСР</li>
                            <li>СДЭК</li>
                            <li>Деловые линии</li>
                            <li>ПЭК</li>
                            <li>Boxberry</li>
                            <li>DPD</li>
                            <li>PonyExpress</li>
                            <li>Major</li>
                            <li>EMS</li>
                            <li>Почта России</li>
                        </ul>`,
      },
      {
        title: 'Получение товара',
        content: `<p>
                        Отнеситесь ответственно к получению товара, если хотите быть уверены в том,
                        что он будет доставлен в сохранности. Не поручайте его детям или сторонним людям,
                        чтобы избежать случайного повреждения при подъеме.
                    </p>`,
      },
    ],
  },

  delivery_payments_payments: {
    display: true,
    definitions: [
      {
        title: 'Наличными',
        content: `<p>
                        Курьер доставит вам товар по указанному адресу.
                        Вы внимательно осматриваете комплектацию и внешний вид продукции, после чего оплачивает
                        ее стоимость, а также стоимость выбранных вами услуг. На привезенные изделия мы предоставим
                        товарный чек и документацию.
                    </p>`,
      },
      {
        title: 'Visa / Mastercard',
        content: `<p>
                        Для удобной оплаты банковской картой используется система электронных платежей Appex.
                        При оформлении заказа выберите способ оплаты с помощью карт Visa или Mastercard, после чего
                        вы перейдете на страницу безопасного платежа.
                    </p>`,
      },
      {
        title: 'Банковский перевод',
        content: `<p>
                        Для осуществления платежа банковским переводом менеджер выставит счет с выбранными
                        товарами и вышлет на вашу электронную почту. Данный способ оплаты по банковским реквизитам
                        компании предусмотрен как для физических, так и для юридических лиц.
                    </p>`,
      },
    ],
  },

  delivery_payments_guarantee: {
    display: true,
    definitions: [
      {
        title: 'Гарантийное обслуживание',
        content: `<p>
                        Если ваше устройство вышло из строя или работает некорректно, обратитесь в наш сервисный центр.
                        Мы дадим консультацию по устранению неполадки.
                        Если не поможет расскажем как сдать в ремонт.
                    </p>
                    <p>
                        Если у производителя нет лицензированного сервисного центра в России, то вам поможет наш сервисный центр.
                    </p>`,
      },
      {
        title: 'Возврат и обмен',
        content: `<p>
                        Возврат и обмен возможен в течение 14 дней после покупку.
                        При оплате наличными возвращаются наличные, при оплате картой возврат на карту.
                        Затраты на доставке не возвращаются.
                    </p>`,
      },
      {
        title: 'Срок гарантии',
        content: `<p>
                        На весь товар действует гарантия 12 месяцев со дня покупки, если не определено иное.
                    </p>`,
      },
    ],
  },

  legal_profile_menu: {
    title: 'Реквизиты',
  },
}
